<selector-toolbar class="selector-toolbar" [disabled]="disabled" [inputSearchText]="inputSearchText"
    [selectedNodesNumber]="materialTree.checklistSelection.selected.length" [status]="status" [title]="title"
    [treeCommandsHandler]="treeCommandsHandler" [treeFilterHandler]="treeFilterHandler"
    [visibleSelectAllButton]="visibleSelectAllButton" (loading)="loading.emit($event)"
    (notifyFocus)="updateFilterFocusState($event)" (notifyStatus)="statusChange.emit($event)">
    <ng-content extra-buttons-before select="[extra-buttons-before]"></ng-content>
</selector-toolbar>

<div class="items-wrapper">

    <ng-container [ngSwitch]="status">

        <!-- #### EDIT Start #### -->
        <ng-container *ngSwitchCase="'edit'">

            <mat-tree class="item-tree edit" [dataSource]="materialTree.dataSource"
                [treeControl]="materialTree.treeControl">
                <!-- Foglie checkbox -->
                <mat-tree-node *matTreeNodeDef="let node; when: !treeUtils.hasChild" matTreeNodeToggle
                    matTreeNodePadding matTreeNodePaddingIndent="25"
                    [class.rootNode]="treeUtils.isVisible(node) && node.level===0"
                    (click)="nodeSelectionHandler.onItemClick(node)" [ngClass]="{
                        'selected-item':
                            nodeSelectionHandler.highlightedNode &&
                            nodeSelectionHandler.highlightedNode.Id === node.Id
                    }">
                    <ng-container *ngIf="treeUtils.isVisible(node)">
                        <div class="expand-space"></div>

                        <mat-checkbox class="checklist-leaf-node" [checked]="treeUtils.isSelected(node)"
                            (change)="nodeSelectionHandler.onItemCheckboxChange(node)"
                            [disabled]="node.selectable === false"
                            (click)="nodeSelectionHandler.onNodeSelectClick(node)" class="node-single">
                            <span class="node-label">{{ node.Description }}</span>
                        </mat-checkbox>

                    </ng-container>
                </mat-tree-node>

                <!-- Foglie radio button -->
                <mat-tree-node *matTreeNodeDef="let node; when: treeUtils.isRadio" matTreeNodeToggle matTreeNodePadding
                    matTreeNodePaddingIndent="25" [class.rootNode]="treeUtils.isVisible(node) && node.level===0"
                    (click)="nodeSelectionHandler.onItemClick(node)" [ngClass]="{
                        'selected-item':
                            nodeSelectionHandler.highlightedNode &&
                            nodeSelectionHandler.highlightedNode.Id === node.Id
                    }">
                    <ng-container *ngIf="treeUtils.isVisible(node)">
                        <div class="expand-space"></div>

                        <mat-radio-button [value]="node.Id" [checked]="treeUtils.isSelected(node)" [name]="node.Id"
                            (change)="nodeSelectionHandler.onItemRadioClick(node)"
                            [disabled]="node.selectable === false"
                            (click)="nodeSelectionHandler.onNodeSelectClick(node)">
                            <span class="node-label">{{ node.Description }}</span>
                        </mat-radio-button>
                    </ng-container>
                </mat-tree-node>

                <!-- Padre -->
                <mat-tree-node *matTreeNodeDef="let node; when: treeUtils.hasChild" matTreeNodePadding
                    matTreeNodePaddingIndent="25" [class.rootNode]="treeUtils.isVisible(node) && node.level === 0"
                    (click)="nodeSelectionHandler.onItemClick(node)" [ngClass]="{
                        'selected-item':
                            nodeSelectionHandler.highlightedNode &&
                            nodeSelectionHandler.highlightedNode.Id === node.Id
                    }">
                    <ng-container *ngIf="treeUtils.isVisible(node)">
                        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{ materialTree.treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                        </button>

                        <mat-checkbox *ngIf="node.checkable" class="checklist-leaf-node"
                            [checked]="treeUtils.isSelected(node)"
                            (change)="nodeSelectionHandler.onItemCheckboxChange(node)"
                            [disabled]="node.selectable === false"
                            (click)="nodeSelectionHandler.onNodeSelectClick(node)">&nbsp;</mat-checkbox>

                        <mat-checkbox *ngIf="!node.checkable" disabled class="checkbox-hidden">&nbsp;</mat-checkbox>

                        <span (click)="treeUtils.toggleGroup(node)" class="span-toggle node-label">{{ node.Description
                            }}</span>

                        <span class="spacer"></span>
                        <group-toolbar [nodeSelectionHandler]="nodeSelectionHandler"
                            [treeCommandsHandler]="treeCommandsHandler" [node]="node"
                            [visibleSelectAllButton]="visibleSelectAllButton" [materialTree]="materialTree"
                            [treeUtils]="treeUtils" [status]="status">
                        </group-toolbar>
                    </ng-container>
                </mat-tree-node>
            </mat-tree>

        </ng-container>


        <!-- #### VIEW Start #### -->
        <ng-container *ngSwitchCase="'view'">
            <div *ngIf="!treeUtils.someSelected()" (click)="onViewNodeClick()" class="container-no-items-label"
                [class.isDisabled]="disabled">
                <p class="no-items-label align-center">
                    <ng-container *ngIf="noItemsSelectedMessage; else defaultNoItemsSelectedMessage">
                        {{ noItemsSelectedMessage }}
                    </ng-container>
                    <ng-template #defaultNoItemsSelectedMessage>
                        {{ 'se-ui-selector-web_no_items_selected' | translate }}
                    </ng-template>
                </p>
            </div>
            <div *ngIf="treeUtils.someSelected()" (click)="onViewNodeClick()" class="container-with-items"
                [class.isDisabled]="disabled">
                <mat-tree class="item-tree view" [dataSource]="materialTree.dataSource"
                    [treeControl]="materialTree.treeControl">
                    <!-- Foglie checkbox -->
                    <mat-tree-node *matTreeNodeDef="let node; when: !treeUtils.hasChild" matTreeNodeToggle
                        matTreeNodePadding matTreeNodePaddingIndent="25" class="view-tree-node"
                        [class.rootNode]="treeUtils.isVisible(node) && node.level === 0">

                        <div (click)="onViewNodeClick()" class="div-mat-tree"
                            *ngIf="treeUtils.isVisible(node) && (!treeUtils.someSelected() || treeUtils.isSelected(node) )">
                            <mat-icon *ngIf="treeUtils.isSelected(node)" aria-hidden="false" aria-label="Selected">
                                check_box
                            </mat-icon>
                            <div *ngIf="!treeUtils.isSelected(node)" class="notChecked"></div>
                            <span class="node-label">{{ node.Description }}</span>
                        </div>

                    </mat-tree-node>

                    <!-- Foglie radio button -->
                    <mat-tree-node *matTreeNodeDef="let node; when: treeUtils.isRadio" matTreeNodeToggle
                        matTreeNodePadding matTreeNodePaddingIndent="25" class="view-tree-node"
                        [class.rootNode]="treeUtils.isVisible(node) && node.level === 0">

                        <div (click)="onViewNodeClick()" class="div-mat-tree"
                            *ngIf="treeUtils.isVisible(node) && (!treeUtils.someSelected() || treeUtils.isSelected(node) )">

                            <mat-icon *ngIf="treeUtils.isSelected(node)" aria-hidden="false" aria-label="Selected">
                                check_box
                            </mat-icon>
                            <!-- radio_button_checked -->
                            <div *ngIf="!treeUtils.isSelected(node)" class="notChecked"></div>
                            <span class="node-label">{{ node.Description }}</span>
                        </div>

                    </mat-tree-node>

                    <!-- Padre -->
                    <mat-tree-node *matTreeNodeDef="let node; when: treeUtils.hasChild" matTreeNodePadding
                        matTreeNodePaddingIndent="25" class="view-tree-node"
                        [class.rootNode]="treeUtils.isVisible(node) && node.level === 0">

                        <div (click)="onViewNodeClick()" class="div-mat-tree"
                            *ngIf="treeUtils.isVisible(node) && (!treeUtils.someSelected() || treeUtils.getChildrenSelectedCount(node) || treeUtils.isSelected(node) )">

                            <mat-icon *ngIf="treeUtils.isSelected(node)" aria-hidden="false" aria-label="Selected">
                                check_box
                            </mat-icon>
                            <div *ngIf="!treeUtils.isSelected(node)" class="notChecked"></div>

                            <span class="span-toggle node-label">{{ node.Description }}</span>

                            <span class="spacer"></span>
                            <group-toolbar [nodeSelectionHandler]="nodeSelectionHandler"
                                [treeCommandsHandler]="treeCommandsHandler" [node]="node"
                                [visibleSelectAllButton]="visibleSelectAllButton" [treeUtils]="treeUtils"
                                [materialTree]="materialTree" [status]="status">
                            </group-toolbar>
                        </div>
                    </mat-tree-node>
                </mat-tree>
            </div>
        </ng-container>

    </ng-container>

</div>
